module.exports = __webpack_public_path__ + "img/descarga.2e3b4246.png";